module.exports = __webpack_public_path__ + "static/media/thumbnail.a8d6f24b.jpg";